import { render, staticRenderFns } from "./ProfileMain.vue?vue&type=template&id=850a08d0&"
import script from "./ProfileMain.vue?vue&type=script&lang=js&"
export * from "./ProfileMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports